function configWordCount(maxWordsParam, showWordCount) {
    let maxWordCount = -1;

    if (!isNaN(maxWordsParam) && maxWordsParam > 0) {
        maxWordCount = maxWordsParam;
    }

    return {
        maxWordCount,
        // Whether or not you want to show the Paragraphs Count
        showParagraphs: false,
        // Whether or not you want to show the Word Count
        showWordCount: showWordCount || maxWordCount > 0,
        showCharCount: false,
        pasteWarningDuration: 0,
    };
}

export default configWordCount;
